import type { OrganizationType } from "@remi/enums/organization-type";
import type { Capability } from "@remi/enums/capability";
import type { ProjectCategory } from "@remi/enums/project-category";
import type { PermissionRole } from "@remi/types/permissions";
import type { RegionRole } from "@remi/types/region";

export type User = {
  person: {
    id: string;
    organizationId: string;
    permissionRoles: PermissionRole[];
    regionRoles: RegionRole[];
    capabilities: Capability[];
  };
};

export type Project = {
  category: ProjectCategory;
  contractorTypeFlow: string | null;
  organizations: {
    type: OrganizationType;
    organization: {
      id: string;
    };
  }[];
};

export const hasCapability = (user: User, capability: Capability): boolean =>
  user.person.capabilities.includes(capability);
